const locale = {
  contracted_projects: "Proyectos contratados",
  other_products: "Otros productos",
  search_projects: "Buscar proyectos/etiquetas",
  select_an_option: "Selecciona una opción",
  no_tags_available: "No hay etiquetas disponibles",
  tag_not_found: "Etiqueta no encontrada",
  select_a_tag: "Selecciona una etiqueta",
  select_an_aoi: "Selecciona una AOI",
  aoi_not_found: "AOI no encontrada",
  no_aois_available: "No hay AOIs disponibles",
  most_used_tags: "Etiquetas más utilizadas",
  add_tag: "Añadir etiqueta",
  delete_tag: "Eliminar etiqueta",
  add_aoi: "Añadir AOI",
  delete_aoi: "Eliminar AOI",
  search: "Buscar",
  header_title: "Amianto: Censo y Plan de Retirada",
  txt_footer_privacity: "Política de privacidad y cookies",
  txt_footer_legal: "Aviso legal",
  txt_description:
    "Los municipios están obligados a realizar un censo de instalaciones y emplazamientos con presencia de amianto, incluyendo un calendario para su retirada, conforme a la Ley 07/2022, de 8 de abril, de residuos y suelos contaminados para una economía circular. Cumple fácilmente con la Ley 07/2022 con nuestra solución.\nAgforest ofrece una solución integral para el censo de instalaciones con amianto, utilizando algoritmos de inteligencia artificial e imágenes satelitales para detectar su presencia en tu localidad.",
  txt_description_title:
    "Censo de Instalaciones con Presencia de Amianto en Municipios - Obligatorio por la Ley 07/2022",
  txt_description_title_information:
    "En esta herramienta, puedes obtener un presupuesto para servicios de teledetección de amianto para municipios, así como análisis que te ayudarán a comprender y aportar información relevante para tu cliente.",
  log_in: "Iniciar sesión",
  password: "Contraseña",
  user_name: "Nombre de usuario",
  do_you_want_to_know_more: "¿Quieres saber más?",
  contact_us: "Contáctanos",
  solutions: "Soluciones",
  asbestos_census: "Censo de amianto",
  water_leaks: "Fugas de agua",
  co2_sinks: "Sumideros de CO2",
  esg_transformation: "Transformación ESG",
  about_agforest: "Sobre AGForest",
  blog: "Blog",
  press_room: "Sala de prensa",
  success_stories: "Casos de éxito",
  about_us: "Sobre nosotros",
  contact: "Contacto",
  innovative_sme: "PYME innovadora",
  valid_until: "Válido hasta el 24 de mayo de 2027",
  privacyand_cookie_policy: "Política de privacidad y cookies",
  legal_notice: "Aviso legal",
  spain: "España",
  success_cases: "Casos de éxito",
  log_out: "Cerrar sesión",
  visit: "Visitar",
  tags: "Etiquetas",
  aois: "AOIs",
  image: "Imagen",
  category: "Categoría",
  description: "Descripción",
  title: "Título",
  grid_view: "Vista de cuadrícula",
  list_view: "Vista de lista",
};

export default locale;
